<div class="contenedor-hemeroteca">
  <table mat-table [dataSource]="videos()">
    <ng-container matColumnDef="tituloVideo">
      <th mat-header-cell *matHeaderCellDef class="td-noticia">Noticia</th>
      <td mat-cell *matCellDef="let row" class="td-noticia">
        <a class="url-noticia" [routerLink]="['/noticias', row?.idVideo, row?.tituloSeo | kebabCase]">{{ row.tituloVideo }}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="idVideo">
      <th mat-header-cell *matHeaderCellDef class="td-seccion">Sección</th>
      <td mat-cell *matCellDef="let row" class="td-seccion">
        <a class="url-seccion" [routerLink]="['/seccion', row?.idSeccion, row?.seccion | kebabCase]">{{ row.seccion }}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="urlVideo">
      <th mat-header-cell *matHeaderCellDef class="td-fecha">Fecha</th>
      <td mat-cell *matCellDef="let row" class="td-fecha">{{ row.fechaPublicacion | date: "Y-M-d" }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</div>

<mat-paginator showFirstLastButtons (page)="pageChanged($event)" [length]="totalLength" [pageSize]="pageLength"></mat-paginator>
